import { render, staticRenderFns } from "./ShangjiaForm.vue?vue&type=template&id=64513ac4"
import script from "./ShangjiaForm.vue?vue&type=script&lang=js"
export * from "./ShangjiaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports